import { memo, useState, type ReactNode } from "react";
import FallbackImage from "./FallbackImage";
import { FaArrowsRotate } from "react-icons/fa6";

interface CardProps {
  children: ReactNode;
}

interface CardLeftProps {
  imgSrc: string;
  imgAlt: string;
  imgLoading?: "eager" | "lazy";
  title: string;
}

export function Card({ children }: CardProps) {
  const [cardOpen, setCardOpen] = useState(false);

  return (
    <div className={`card ${cardOpen ? "card-open" : ""}`}>
      <button
        type="button"
        className="card-flip-button"
        onClick={() => setCardOpen((current) => !current)}
        aria-pressed={cardOpen}
        aria-label={cardOpen ? "Flip card to front" : "Flip card to details"}
      >
        <FaArrowsRotate aria-hidden="true" />
        <span className="visually-hidden">{cardOpen ? "Show card front" : "Show card details"}</span>
      </button>
      {children}
    </div>
  );
}

function CardLeftComponent({ imgSrc, imgAlt, imgLoading, title }: CardLeftProps) {
  return (
    <div className="card-left">
      <FallbackImage src={imgSrc} alt={imgAlt} className="card-left-img" width="350" height="515" loading={imgLoading} />
      <h2 className="card-left-title">{title}</h2>
    </div>
  );
}

function CardRightComponent({ children }: CardProps) {
  return <div className="card-right">{children}</div>;
}

export const CardLeft = memo(CardLeftComponent);
export const CardRight = memo(CardRightComponent);
